import { AxiosError } from 'axios';

export default function isAxiosError(err: unknown) {
  const error = err as AxiosError | undefined;

  return !!error?.isAxiosError;
}
